import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {Card} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import API from '../../api/api.jsx';
import Detail001 from './detail_001.jsx';  // 버튼
import Detail002 from './detail_002.jsx';  // nav-pills
import basicUser from '../../assets/img/basic_user.jpg'
import { MEDIA_BASE_URL } from '../../config/app-axios.jsx';

// 환경파일에 있는 서버 URL
const mediaUrl = MEDIA_BASE_URL;

// 상세 화면
const Detail = () => {
	const { t }                             = useTranslation();
	const { loanReceivableId }              = useParams();
	const [customerInfo, setCustomerInfo]   = useState(null);
	const [filePath, setFilePath]           = useState('');
	const [fileExtension, setFileExtension] = useState('');
	const [imageSrc, setImageSrc]           = useState('');

	const fetchData = async () => {
		try {
			const data = await API.fetchBondDetailData({
				loanReceivableId: loanReceivableId.split('=')[1],
			});

			setCustomerInfo(data[0]);
	
			// 파일 다운로드를 위한 데이터가 있는 경우에만 파일 데이터 가져오기
			if (data[0]?.file_id) {
				await fetchFileData(data[0].file_id);
			}

		} catch (error) {
			console.error('Error in fetchBondDetailData:', error);
		}
	};

	const fetchFileData = async (fileId) => {
		try {
			const fileData = await API.fetchDownloadFileData({
				fileId,
			});

			setFilePath(fileData[0].file_path);
			setFileExtension(fileData[0].file_extension);

		} catch (error) {
			console.error('Error in fetchDownloadFileData:', error);
		}
	};
	useEffect(() => {
		fetchData();
	}, [loanReceivableId]);

	useEffect(() => {
		// imageSrc 상태에 미디어 파일의 경로를 포함한 URL을 설정합니다.
		const updatedImageSrc = filePath !== '' ? `${mediaUrl}${filePath}` : '';

		setImageSrc(updatedImageSrc);

	}, [filePath, fileExtension]);

	const profileBoxStyle = {
		width: '200px',
		height: '200px',
		border: '1px solid #ffffff',    // 테두리 스타일 및 색상 지정
		padding: '10px',               // 내부 여백 설정
		backgroundImage: `url(${imageSrc || basicUser})`,
		backgroundSize: '100% 100%',
	};

	// 화면 상단의 고객 정보 html
	const InquiryInfoItem = ({ label, value }) => (
		<div className="row mb-15px">
			<label className="form-label col-form-label col-md-3" htmlFor="">{label}</label>

			<div className="col-md-9 d-flex align-items-center">
				<span>{value}</span>
			</div>
		</div>
	);

	// API 통신 결과 값의 유저정보를 전달 받아서 각 라벨의 value로 넣는 부분
	const InquiryInfo = ({ customerInfo }) => {
		return (
			<div className="col-md-10">
				<InquiryInfoItem label={t(`LOAN_RECEIVABLE_INQUIRY.성명`, { defaultValue: '성명' })} value={customerInfo.customer_name} />
				<InquiryInfoItem label={t(`LOAN_RECEIVABLE_INQUIRY.생년월일`, { defaultValue: '생년월일' })} value={moment(customerInfo.birth_date).format('DD/MM/YYYY')} />
				<InquiryInfoItem label={t(`LOAN_RECEIVABLE_INQUIRY.주소`, { defaultValue: '주소' })} value={customerInfo.address} />
				<InquiryInfoItem label={t(`LOAN_RECEIVABLE_INQUIRY.전화번호`, { defaultValue: '전화번호' })} value={customerInfo.phone_number} />
			</div>
		);
	};

	// 화면 UI
	return (
		<Card style={{ height: '100%' }}>
			{/* <Card.Header><strong>{t(`LOAN_RECEIVABLE_INQUIRY.계약번호`, { defaultValue: '계약번호' })} : { loanReceivableId.split('=')[1] }</strong></Card.Header> */}
			<Card.Header><strong>{t(`LOAN_RECEIVABLE_INQUIRY.계약번호`, { defaultValue: '계약번호' })} : {`${loanReceivableId.split('=')[1].slice(0, 6)}-${loanReceivableId.split('=')[1].slice(6, 9)}-${loanReceivableId.split('=')[1].slice(9,15)}-${loanReceivableId.split('=')[1].slice(15)}`} </strong></Card.Header>
			{/* {`${loanReceivableId.split('=')[1].slice(0, 6)}-${loanReceivableId.split('=')[1].slice(6, 8)}-${loanReceivableId.split('=')[1].slice(8, 12)}-${loanReceivableId.split('=')[1].slice(12)}`} */}
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					<div className="row">
						<div className="col-md-2 mb-9px">
							<div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
								<div style={profileBoxStyle} />
							</div>
						</div>

						{/* 고객 정보 */}
						<div className="col-md-10 mb-9px">
							{customerInfo && <InquiryInfo customerInfo={customerInfo} />}
						</div>
					</div>

					{/* 버튼 관련 */}
					<div className="row">
						<Detail001 customerInfo={customerInfo} />
					</div>

					{/* nav-pills 관련 */}
					<div className='row'>
						<Detail002 customerInfo={customerInfo} />
					</div>
				</div>
			</Card.Body>
		</ Card>
	);
};

export default Detail;